// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Incident API
 * API to get incident information
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HandlerSeverity } from './HandlerSeverity';
import {
  HandlerSeverityFromJSON,
  HandlerSeverityFromJSONTyped,
  HandlerSeverityToJSON,
  HandlerSeverityToJSONTyped,
} from './HandlerSeverity';
import type { HandlerStatus } from './HandlerStatus';
import {
  HandlerStatusFromJSON,
  HandlerStatusFromJSONTyped,
  HandlerStatusToJSON,
  HandlerStatusToJSONTyped,
} from './HandlerStatus';
import type { TypesCustomFields } from './TypesCustomFields';
import {
  TypesCustomFieldsFromJSON,
  TypesCustomFieldsFromJSONTyped,
  TypesCustomFieldsToJSON,
  TypesCustomFieldsToJSONTyped,
} from './TypesCustomFields';

/**
 *
 * @export
 * @interface HandlerIncidentResponse
 */
export interface HandlerIncidentResponse {
  /**
   *
   * @type {TypesCustomFields}
   * @memberof HandlerIncidentResponse
   */
  customFields?: TypesCustomFields;
  /**
   *
   * @type {string}
   * @memberof HandlerIncidentResponse
   */
  incidentId?: string;
  /**
   *
   * @type {string}
   * @memberof HandlerIncidentResponse
   */
  incidentName?: string;
  /**
   *
   * @type {HandlerSeverity}
   * @memberof HandlerIncidentResponse
   */
  severity?: HandlerSeverity;
  /**
   *
   * @type {string}
   * @memberof HandlerIncidentResponse
   */
  slackChannelId?: string;
  /**
   *
   * @type {string}
   * @memberof HandlerIncidentResponse
   */
  slackChannelName?: string;
  /**
   *
   * @type {HandlerStatus}
   * @memberof HandlerIncidentResponse
   */
  status?: HandlerStatus;
}

/**
 * Check if a given object implements the HandlerIncidentResponse interface.
 */
export function instanceOfHandlerIncidentResponse(
  value: object,
): value is HandlerIncidentResponse {
  return true;
}

export function HandlerIncidentResponseFromJSON(
  json: any,
): HandlerIncidentResponse {
  return HandlerIncidentResponseFromJSONTyped(json, false);
}

export function HandlerIncidentResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HandlerIncidentResponse {
  if (json == null) {
    return json;
  }
  return {
    customFields:
      json['custom_fields'] == null
        ? undefined
        : TypesCustomFieldsFromJSON(json['custom_fields']),
    incidentId: json['incident_id'] == null ? undefined : json['incident_id'],
    incidentName:
      json['incident_name'] == null ? undefined : json['incident_name'],
    severity:
      json['severity'] == null
        ? undefined
        : HandlerSeverityFromJSON(json['severity']),
    slackChannelId:
      json['slack_channel_id'] == null ? undefined : json['slack_channel_id'],
    slackChannelName:
      json['slack_channel_name'] == null
        ? undefined
        : json['slack_channel_name'],
    status:
      json['status'] == null
        ? undefined
        : HandlerStatusFromJSON(json['status']),
  };
}

export function HandlerIncidentResponseToJSON(
  json: any,
): HandlerIncidentResponse {
  return HandlerIncidentResponseToJSONTyped(json, false);
}

export function HandlerIncidentResponseToJSONTyped(
  value?: HandlerIncidentResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    custom_fields: TypesCustomFieldsToJSON(value['customFields']),
    incident_id: value['incidentId'],
    incident_name: value['incidentName'],
    severity: HandlerSeverityToJSON(value['severity']),
    slack_channel_id: value['slackChannelId'],
    slack_channel_name: value['slackChannelName'],
    status: HandlerStatusToJSON(value['status']),
  };
}
